export default __webpack_public_path__ + "static/media/undraw_cancel_u1it.af270bf0.svg";